import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m23.976 20.428 2.052 2.827 3.322-1.077-2.055 2.824 2.051 2.826-3.32-1.08-2.055 2.823.002-3.492-3.32-1.081 3.321-1.077.002-3.493Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M18.378 32.065a7.065 7.065 0 1 1 3.36-13.281 8.695 8.695 0 1 0 0 12.432c-.999.541-2.144.85-3.36.85Z"
}));
FlagTR.displayName = 'FlagTR';
export default withFlagWrapper(FlagTR);
//# sourceMappingURL=index.js.map